import {useNavigate, Link, Route, Routes} from 'react-router-dom'
import React, {useEffect} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {Button} from "@mui/material";
import MapsView from "./screens/frontend/Maps";
import SpaceView from "./screens/frontend/SpaceView";
import SpacesMapSelect from "./screens/frontend/SpacesMapSelect";
import Home from "./screens/frontend/Home";
import Participate from "./screens/frontend/Participate";
import Privacy from "./screens/frontend/Privacy";
import About from "./screens/frontend/About";
import '@fontsource/space-grotesk';

// import NotFound from "./screens/frontend/NotFound";
import {FrontendLayout} from './components';
import {AuthProvider} from './context/AuthProvider'
import { HelmetProvider } from 'react-helmet-async';
import {AdminMessageProvider} from './context/AdminMessageContext';
import './css/frontend.css';
import {useTranslation} from "react-i18next";

const Frontend = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    // Set language to Greek after first render
    useEffect(() => {
        i18n.changeLanguage('el');
    }, [i18n]);
    return (
        <>
            <ErrorBoundary
                FallbackComponent={() => (
                    <ErrorFallback goBack={() => navigate(-1)}/>
                )}
                onError={console.error}
            >
                <AdminMessageProvider>

                <AuthProvider>

                {/*<ShoppingContextProvider>*/}
                <HelmetProvider>
                        <FrontendLayout showAdminNavigation={true}>
                        <Routes>
                            <Route path='/' element={<MapsView/>}/>
                            <Route path='/about' element={<About/>}/>
                            <Route path='/spaces' element={<MapsView/>}/>
                            <Route path='/space-view/:id' element={<SpaceView/>}/>
                            <Route path='/map-select' element={<SpacesMapSelect/>}/>
                            <Route path='/participate' element={<Participate/>}/>
                            <Route path='/privacy' element={<Privacy/>}/>
                            <Route path='/home' element={<Home/>}/>
                            <Route path='/map' element={<MapsView/>}/>
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </FrontendLayout>
                </HelmetProvider>
                </AuthProvider>
            </AdminMessageProvider>

            {/*</ShoppingContextProvider>*/}

            </ErrorBoundary>
        </>
    )
}

    function ErrorFallback({error, goBack}) {
        const errorMessage = error && error.message ? error.message : "Unknown error";
        // const isDebugMode = process.env.NODE_ENV === 'development';
        // const errorStack = error && error.stack ? error.stack : "No stack trace";

        return (

            <div className="main-user-error-message-block">
                <div className="user-error-message-block">
                    <p>Something went wrong 😭</p>
                    <span>Error: {errorMessage}</span>
                    {/*{isDebugMode && (*/}
                    {/*    <>*/}
                    {/*        <p>Stack Trace:</p>*/}
                    {/*        <pre>{errorStack}</pre>*/}
                    {/*    </>*/}
                    {/*)}*/}
                    <p>-</p>
                    <p>
                        <Link to={"/"} className="shop_go_to_frontend_link">
                            GO TO FRONTEND
                        </Link>
                    </p>
                    <p>
                        <Button onClick={goBack}>Go Back</Button>
                    </p>
                </div>
            </div>
        );
    }

export default Frontend
